module.exports = __webpack_public_path__ + "media/yeah_baby.8c68e51f.mp3";